import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getAll(payload) {
    const result = await axios.post(apiUrl + "/admin/getbrokers",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getusers(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/getusers",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}

async function getBrokerage(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/getbrokerage",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}

async function valanDates(payload) {
    const result = await axios.get(apiUrl + "/admin/get/valandates",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

export const BrokerAgeReportServices = {
    getAll,
    getusers,
    getBrokerage,
    valanDates
}